<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>

      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Reporte de detalle de ingresos</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>RI_02_detalle_ingresos</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          Búsqueda de clinicas
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>

              <b-form-group align="left">
                <label for="clinica">Clinicas</label>
                <v-select v-if="!todas" name="clinica" placeholder="Clinicas"
                          label="strNombre"
                          multiple
                          :reduce="(variable) => variable.idClinica"
                          :options="clinicas"
                          v-model="filtro.idClinicas"
                ></v-select>
                <b-form-checkbox
                    id="checkbox-1"
                    v-model="todas"
                    name="checkbox-1"
                    @change="todos()">
                  Todas las clinicas
                </b-form-checkbox>
              </b-form-group>

            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group align="left">
                <label for="fci">Fecha de inicio</label>
                <b-input-group size="sm" class="mb-2" id="fci" lab>
                  <b-form-datepicker name="nombre" placeholder="Fecha de Inicio"
                                     v-model="$v.filtro.fechaInicio.$model"
                                     :state="validateState('fechaInicio')"
                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group align="left">
                <label for="fcf">Fecha de fin</label>
                <b-input-group size="sm" class="mb-2" id="fcf" lab>
                  <b-form-datepicker name="nombre" placeholder="Fecha de Fin"
                                     :min="filtro.fechaInicio"
                                     :max="new Date()"
                                     v-model="$v.filtro.fechaFin.$model"
                                     :state="validateState('fechaFin')"

                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col></b-col>
            <b-col></b-col>
            <b-col class="text-right">
              <b-button variant="outline-primary" :disabled="loader" @click="obtenerDatos()">
                <span v-if="!loader">Buscar</span>
                <span v-else>
                                     <b-spinner small></b-spinner>
                                    Buscando...
                                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col cols="12">
          <download-excel
              v-if="datosTabla.length > 0"
              class="btn btn-primary"
              :data="datosTabla"
              :fields="fieldsExcel"
              worksheet="DetalleIngresosClinicas"
              name="reporte de ingresos.xls"
          >
            Generar Excel
            <em class="fa fa-file-excel-o"></em>
          </download-excel>
        </b-col>
        <b-col cols="12">
          <div v-if="!loader" class="overflow-auto">
            <b-table
                id="Pendientes"
                thead-tr-class="columnas"
                :items="datosTabla"
                :fields="fields"
                striped
                responsive="true"
                class="parrafos"
            >
              <template #thead-top="data">
                <b-tr>
                  <b-th colspan="3"></b-th>
                  <b-th v-for="(item, index) in formas" :key="item.nombreForma" :variant="index%2 === 0 ? 'primary': 'secondary'" :colspan="item.cantidad">
                    {{ item.nombreForma }}
                  </b-th>
                </b-tr>
              </template>
              <template v-slot:cell(monto)="row">
                {{ row.item.monto | monedaEntero }}
              </template>
            </b-table>
          </div>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="buscado">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <!--                    <b-col v-if="!loader">-->
          <!--                        <b-pagination-->
          <!--                                v-if="datosTabla !== undefined && datosTabla.length > 10"-->
          <!--                                align="center"-->
          <!--                                v-model="paginaActual"-->
          <!--                                :total-rows="datosTabla.length"-->
          <!--                                :per-page="registrosPorPagina"-->
          <!--                                aria-controls="my-table1"-->
          <!--                        ></b-pagination>-->
          <!--                    </b-col>-->
        </b-col>


      </b-row>

    </b-container>

  </div>
</template>

<script>
import Header from "../../../components/Header";
import {required} from "vuelidate/lib/validators";

export default {
  components: {
    Header
  },
  name: "ReporteIngresoDetalle",
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loader: false,
      buscado: false,
      datosTabla: [],
      totalFilas:  0,
      formas: [],
      fields: [
        {key: "clinica", label: "Clínica"},
        {key: "fecha", label: "Fecha"},
        {key: "monto", label: "Ingreso"}
      ],
      fieldsExcel: "",
      registrosPorPagina: 10,
      paginaActual: 0,

      show: false,
      filtro: {
        idClinicas: [],
        fechaInicio: null,
        fechaFin: null
      },

      clinicas: [],
      todas: false
    }
  },
  validations: {
    filtro: {
      fechaInicio: {required},
      fechaFin: {required},
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerClinicas()
  },
  methods: {
    obtenerClinicas() {
      this.$http.get(this.$api + 'catalogos/listaClinicas').then(respuesta => {
        if (respuesta.data.data) {
          this.clinicas = respuesta.data.data;
        }
      })
    },
    obtenerDatos() {
      this.$v.filtro.$touch();

      if (!this.todas && this.filtro.idClinicas.length == 0) {
        this.$swal({
          icon: "error",
          text: "Debe seleccionar al menos una clínica para realizar la búsqueda",
        });
      } else {
        if (!this.$v.filtro.$invalid) {
          this.loader = true
          this.buscado = false
          this.datosTabla = [];
          const envio = {
            idClinicas: this.todas ? [-1] : this.filtro.idClinicas,
            fechaInicio: this.$moment(this.filtro.fechaInicio).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
            fechaFin: this.$moment(this.filtro.fechaFin).add(1, 'days').utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
            horas: this.$horas()
          }


          this.$http.post(this.$api + 'finanzas/reporte/ingresos/detalle', envio).then(respuesta => {
                if (respuesta.data.data) {
                  this.totalFilas = 3
                  this.formas = respuesta.data.data.formas
                  this.formas.map(value => {
                    this.totalFilas = value.cantidad;
                  })

                  // this.datosTabla = respuesta.data.data.ingresos
                  this.armarFields(respuesta.data.data.formas);
                  this.armarFilas(respuesta.data.data.ingresos);

                  this.datosTabla.forEach(dt => {

                    const llavesExistentes = Object.keys(dt);

                    this.fields.forEach(fieldDT => {

                      if(!llavesExistentes.some(ll => ll === fieldDT.key)) {
                        dt[fieldDT.key] = "-";
                      }
                    });
                  });
                }
              }
          ).finally(() => {
                this.loader = false;
                this.buscado = true;
              }
          )
        }
      }


    },
    armarFields(item) {
      let excel = '{ "Clínica" : "clinica", "Fecha" : "fecha", "Ingreso" : "monto" ';
      this.fields = [
        {key: "clinica", label: "Clínica"},
        {key: "fecha", label: "Fecha"},
        {key: "monto", label: "Ingreso"}
      ];
      item.forEach(row => {
        if (row.terminales.length > 0) {
          row.terminales.forEach(it => {
            this.fields.push({key: it.clave, label: it.nombre})
            excel += ', "' + row.nombreForma + '-' + it.nombre + '":' + '"' + it.clave + '"';

          })
        }else {
          this.fields.push({key: row.nombreForma, label: row.nombreForma})
          excel += ', "' + row.nombreForma +'":' +'"' + row.nombreForma +'"';
        }
      });

      excel += '}';
      this.fieldsExcel = JSON.parse(excel);
    },
    armarFilas(item) {
      this.datosTabla = [];
      item.forEach(item => {
        let clavesNoExisten = []

        this.formas.map(f =>{
          f.terminales.map(t => {
            clavesNoExisten.push(t)
          })
        })


        let dato = '{"clinica":' + '"' + item.clinica + '"';
        dato = dato + ',"fecha":' + '"' + item.fecha + '"';
        dato = dato + ',"monto":' + '"' + item.monto + '"';
        item.terminales.map(it => {
          clavesNoExisten = clavesNoExisten.filter(c => {return c.clave !=  it.clave})
          dato = dato + ','
              + ' "' + it.clave + '" '
              + ' : ' +
              ' "' +
              this.$options.filters.monedaEntero(it.monto) + '"';
        })

        clavesNoExisten.map(it=>{
          dato = dato + ','
              + ' "' + it.clave + '" '
              + ' : ' +
              ' " - "';
        })


        dato = dato + "}"


        this.datosTabla.push(JSON.parse(dato));
      })
    },
    detalle(item) {
      this.datosTablaDetalle = item.detalle;
      this.registrosPorPaginaDetalle = 10;
      this.paginaActualDetalle = 0
      this.show = true;
    },
    cerrarModal() {
      this.show = false;
    },
    todos() {
      this.todas = !this.todas;
      this.filtro.idClinicas = []
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.filtro[name];
      return $dirty ? !$error : null;
    },
  }
}
</script>

<style scoped>

</style>
